// extracted by mini-css-extract-plugin
module.exports = {"column-value":"other-setting_column-value__2EgWV","row":"other-setting_row__2w1ab"};